import { useGetBlogsQuery } from '@apis/mediacore/blog'
import { makeItemsNav } from '@helpers/helper.rendering'
import useQuerySummary from '@hooks/useQuerySummary'
import { Link } from 'gatsby'
import React, { Fragment, useEffect, useState } from 'react'
import { Col, Container, Nav, Navbar, Row } from 'react-bootstrap'
import { RealEstateDataHeaderData, RealEstateDataPage } from 'types'
import { useLocation } from '@reach/router'
import { useGetJobsQuery } from '@apis/mediacore/jobs'

interface ExternalProps {
  pages: RealEstateDataPage[]
  development_id: string
  property_id: string
  novelty_id: string
}

type CombinedProps = RealEstateDataHeaderData & ExternalProps

const Header7 = (props: CombinedProps) => {
  const { global_data, pages, height, logoSize, fontColor, backgroundColor } = props

  const { id: siteId } = global_data
  const API_KEY = global_data.pageConfig.keys.tokko

  const { data: allBlogData } = useGetBlogsQuery({ site: siteId })
  const { allSummaryData } = useQuerySummary({ API_KEY })
  const { data: allJobsData } = useGetJobsQuery({ site: siteId })

  const logo = global_data.logo
  const logoMobile = global_data.logoMobile

  const [isMounted, setIsMounted] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)

  const handleMenuToggle = () => {
    setMenuOpen(!menuOpen)
  }

  const location = useLocation()

  useEffect(() => {
    setIsMounted(true)
    document.documentElement.style.setProperty(
      '--backgroundMobileColor',
      backgroundColor || '#f8f8f8',
    )
    document.documentElement.style.setProperty('--fontMobileColor7', fontColor || '#f8f8f8')
    document.documentElement.style.setProperty(
      '--navbar-height',
      height?.desktop
        ? screen.width < 992
          ? height.mobile + (height.scalePixels ? 'px' : 'vh')
          : height.desktop + (height.scalePixels ? 'px' : 'vh')
        : '120px',
    )
  }, [])

  const itemsNav = makeItemsNav(allSummaryData, allBlogData, pages, allJobsData).filter(
    (page) => !page.path.includes('detalle'),
  )

  return isMounted ? (
    <header
      id="header"
      className="header d"
    >
      <Navbar className="navbar-sticky py-0">
        <Container
          fluid
          className="mx-lg-3"
          style={{ maxWidth: '100%', height: '100%' }}
        >
          <Row className="w-100 d-xl-flex d-none align-items-center justify-content-center  slide-in-up">
            <Col
              lg={4}
              className="d-flex links-column-left"
            >
              <Nav className="nav-menu d-flex justify-content-between w-100">
                {itemsNav.slice(0, Math.ceil(itemsNav.length / 2)).map(({ path, title }, index) => (
                  <Fragment key={index}>
                    <Nav.Item className="slide-in-up">
                      {path.includes('venta') ||
                      path.includes('alquiler') ||
                      (path.includes('temporario') && !location.pathname.includes(path)) ? (
                        <a
                          style={{ color: fontColor || '#fff' }}
                          className={
                            (location.pathname.includes(path) &&
                              location.pathname !== '' &&
                              path !== '/') ||
                            (path === '/' && location.pathname === '/')
                              ? 'custom-link active text-nowrap'
                              : 'custom-link text-nowrap'
                          }
                          href={path}
                        >
                          {title}
                        </a>
                      ) : (
                        <Link
                          onClick={() => {
                            scrollTo(0, 0)
                          }}
                          style={{ color: fontColor || '#fff' }}
                          className={
                            (location.pathname.includes(path) &&
                              location.pathname !== '' &&
                              path !== '/') ||
                            (path === '/' && location.pathname === '/')
                              ? 'custom-link active text-nowrap'
                              : 'custom-link text-nowrap'
                          }
                          to={path}
                        >
                          {title}
                        </Link>
                      )}
                    </Nav.Item>
                  </Fragment>
                ))}
              </Nav>
            </Col>
            <Col
              lg={4}
              className="d-flex justify-content-center align-items-center px-xl-5"
            >
              <Link
                aria-label="Enlace inicio"
                className="d-flex align-items-center m-0"
                to="/"
              >
                <img
                  alt="logo-header"
                  src={logo}
                  height={
                    logoSize && height?.desktop
                      ? screen.width < 992
                        ? (parseInt(height?.mobile) * parseInt(logoSize)) / 100 + 'px'
                        : (parseInt(height?.desktop) * parseInt(logoSize)) / 100 + 'px'
                      : '45px'
                  }
                  width={'auto'}
                  className="d-lg-inline-block d-none align-top logo-header slide-in-up"
                />
              </Link>
            </Col>
            <Col
              lg={4}
              className="d-flex links-column-right"
              style={{ alignSelf: 'center', justifyContent: 'flex-start' }}
            >
              <Nav className="nav-menu d-flex justify-content-between w-100">
                {itemsNav.slice(Math.ceil(itemsNav.length / 2)).map(({ path, title }, index) => (
                  <Fragment key={index}>
                    <Nav.Item className="me-3 slide-in-up">
                      {path.includes('venta') ||
                      path.includes('alquiler') ||
                      (path.includes('temporario') && !location.pathname.includes(path)) ? (
                        <a
                          style={{ color: fontColor || '#fff' }}
                          className={
                            (location.pathname.includes(path) &&
                              location.pathname !== '' &&
                              path !== '/') ||
                            (path === '/' && location.pathname === '/')
                              ? 'custom-link active text-nowrap'
                              : 'custom-link text-nowrap'
                          }
                          href={path}
                        >
                          {title}
                        </a>
                      ) : (
                        <Link
                          onClick={() => {
                            scrollTo(0, 0)
                          }}
                          style={{ color: fontColor || '#fff' }}
                          className={
                            (location.pathname.includes(path) &&
                              location.pathname !== '' &&
                              path !== '/') ||
                            (path === '/' && location.pathname === '/')
                              ? 'custom-link active text-nowrap'
                              : 'custom-link text-nowrap'
                          }
                          to={path}
                        >
                          {title}
                        </Link>
                      )}
                    </Nav.Item>
                  </Fragment>
                ))}
              </Nav>
            </Col>
          </Row>
          <Row className="w-100 h-100 d-flex justify-content-center align-items-center d-xl-none d-block">
            <Col
              xs={2}
              className="d-flex justify-content-center align-items-center"
            >
              <button
                aria-label="toggle"
                className="toggle-nav d-xl-none"
                onClick={handleMenuToggle}
              >
                <div className="d-flex align-items-center">
                  <span>
                    {menuOpen ? (
                      <span className="icon-close-light close-icon" />
                    ) : (
                      <>
                        {' '}
                        <i></i>
                        <i></i>
                        <i></i>
                      </>
                    )}
                  </span>
                </div>
              </button>
            </Col>
            <Col
              xs={10}
              className="px-0 h-100 d-flex justify-content-end align-items-center"
            >
              <Link
                aria-label="Enlace inicio"
                className="d-xl-block d-flex align-items-end m-0"
                to="/"
              >
                <img
                  alt="logo-header-mobile"
                  src={logoMobile}
                  style={{
                    maxHeight: '40px',
                    maxWidth: '100%',
                  }}
                  className="d-xl-none d-block align-top pe-3"
                />
              </Link>
            </Col>
          </Row>
        </Container>
      </Navbar>
      {menuOpen && (
        <div className={`mobile-menu open`}>
          <Nav className="d-flex flex-column nav-item show">
            {makeItemsNav(allSummaryData, allBlogData, pages, allJobsData)
              .filter((page) => !page.path.includes('detalle') && !page.path.includes('favoritos'))
              .map(({ path, title }, index) => (
                <Fragment key={index}>
                  <Nav.Item className="my-3 ms-5">
                    {path.includes('venta') ||
                    path.includes('alquiler') ||
                    (path.includes('temporario') && !location.pathname.includes(path)) ? (
                      <a
                        className={
                          (location.pathname.includes(path) &&
                            location.pathname !== '' &&
                            path !== '/') ||
                          (path === '/' && location.pathname === '/')
                            ? 'custom-link active'
                            : 'custom-link'
                        }
                        href={path}
                        onClick={() => setMenuOpen(false)}
                      >
                        {title}
                      </a>
                    ) : (
                      <Link
                        onClick={() => {
                          scrollTo(0, 0)
                          setMenuOpen(false)
                        }}
                        className={
                          (location.pathname.includes(path) &&
                            location.pathname !== '' &&
                            path !== '/') ||
                          (path === '/' && location.pathname === '/')
                            ? 'custom-link active'
                            : 'custom-link'
                        }
                        to={path}
                      >
                        {title}
                      </Link>
                    )}
                  </Nav.Item>
                </Fragment>
              ))}
          </Nav>
        </div>
      )}
    </header>
  ) : (
    ''
  )
}

export default Header7
